import { Instance, types } from 'mobx-state-tree'
import { selectOptionFromString, SelectOptions } from '../../components/Select/Select'
import { IsEditingModel } from '../IsEditingModel'
import { CenterModel } from './CenterModel'
import { DeploymentSettingsModel } from './DeploymentSettingsModel'

export const CenterSettingsModel = IsEditingModel.named('CenterSettingsModel')
.props({
  center: CenterModel,
  deploymentSettings: DeploymentSettingsModel,
  timezones: types.array(types.string),
})
.views((self) => ({
  get timezoneSelectOptions() : SelectOptions {
    return self.timezones.map(tz => selectOptionFromString(tz))
  }
}))

export type CenterSettings = Instance<typeof CenterSettingsModel>